import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfigService } from '@fmnts/api';
import { map, Observable } from 'rxjs';
import { FeedbackForm, FeedbackFormAdapter } from '../model/feedback-form';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class FeedbackFormApi {
  private static readonly rootUrl = '/feedback/';
  private feedbackFormAdapter = new FeedbackFormAdapter();

  constructor(
    private http: HttpClient,
    private configService: ApiConfigService,
  ) {}

  /**
   * Fetches a feedback form for a specific hash
   *
   * @param hash The hash with which the feedback id
   */
  get(hash: string): Observable<FeedbackForm> {
    const url = this.configService.buildApiUrl([FeedbackFormApi.rootUrl, hash]);

    return this.http
      .get(url)
      .pipe(map((response) => this.feedbackFormAdapter.adapt(response)));
  }

  /**
   * Saves the result of the feedback survey
   *
   * @param hash The hash with which the feedback should be saved
   * @param form The form data which should be saved
   */
  save(
    hash: string,
    form: Record<string, unknown>,
  ): Observable<Record<string, unknown>> {
    const url = this.configService.buildApiUrl([FeedbackFormApi.rootUrl, hash]);

    return this.http.patch<Record<string, unknown>>(url, form, httpOptions);
  }
}
